import React from "react";
import { InputNumber, Input } from "antd";
import trim from "lodash/trim";
import toString from "lodash/toString";
import classNames from "classnames";
import WeaHelpfulTip from "../wea-helpful-tip";
import "./index.less";
import middleware from "../../middleware";
import {
  desensitization,
  encryption,
  replaceEncryption
} from "../wea-tools/Encry.base";
import WeaInputAuth from "../base/wea-input-auth";

const maxNumber = 999999999999999;

class Main extends React.PureComponent {
  static defaultProps = {
    max: maxNumber
  };

  onBlur = e => {
    this.props.onBlur && this.props.onBlur(e.target.value);
  };

  render() {
    let { value, precision } = this.props;
    const { className = "", style = {}, children, ...resProps } = this.props;
    const {
      viewAttr,
      hasBorder,
      underline,
      tip,
      ecId,
      hasInput,
      alignRight,
      helpfulTip,
      helpfulTipProps
    } = resProps;
    const req = classNames({
      required:
        (viewAttr === 3 || viewAttr === "3") &&
        trim(toString(value)).length === 0
    });

    const readonly = classNames({
      border: hasBorder,
      underline: underline
    });
    // 加密数据处理
    if (
      value !== "" &&
      !isNaN(Number(precision)) &&
      !(desensitization(value) || encryption(value))
    ) {
      value = Number(value).toFixed(precision);
      // console.log(value, precision);
    }
    if (viewAttr == "1") {
      if (desensitization(value)) {
        return [<WeaInputAuth {...resProps} value={value} />, children];
      } else if (encryption(value)) {
        value = replaceEncryption(value);
      }
      if (hasInput) {
        const textAlign = classNames({
          right: alignRight
        });
        return (
          <div className={`wea-input-number ${className}`} style={style}>
            <Input
              ecId={`${ecId}_Input@7iuyx2`}
              className={`has-input ${textAlign}`}
              value={value}
              readOnly
            />
            {helpfulTip && (
              <WeaHelpfulTip
                ecId={`${ecId}_WeaHelpfulTip@7iuyx2`}
                style={{ position: "absolute", right: -31, top: 4 }}
                title={helpfulTip}
                {...helpfulTipProps}
              />
            )}
          </div>
        );
      }
      return (
        <div
          className={`wea-field-readonly ${readonly} ${this.props.className ||
            ""}`}
          style={style}
        >
          <span
            className="child-item wdb"
            dangerouslySetInnerHTML={{ __html: value }}
          />
          {helpfulTip && (
            <WeaHelpfulTip
              ecId={`${ecId}_WeaHelpfulTip@p83jc8`}
              style={{ position: "absolute", right: -31, top: 4 }}
              title={helpfulTip}
              {...helpfulTipProps}
            />
          )}
        </div>
      );
    }

    return (
      <div className={`wea-input-number ${req} ${className}`} style={style}>
        <InputNumber
          {...resProps}
          ecId={`${ecId}_InputNumber@0ui38g`}
          precision={this.props.precision || 0}
          onBlur={this.onBlur}
        />
        {tip && (
          <div
            className="input-tip"
            style={{ marginLeft: 14 }}
            dangerouslySetInnerHTML={{ __html: tip }}
          />
        )}
        {helpfulTip && (
          <WeaHelpfulTip
            ecId={`${ecId}_WeaHelpfulTip@vx6jzd`}
            style={{ position: "absolute", right: -31, top: 4 }}
            title={helpfulTip}
            {...helpfulTipProps}
          />
        )}
        {children}
      </div>
    );
  }
}

const Com = middleware(Main, "WeaInputNumber");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-input-number/index.js